import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';

import { bgBlur } from 'src/theme/css';

import Iconify from '../iconify';

// ----------------------------------------------------------------------

export default function ViewButton({ onView }) {
  const theme = useTheme();

  return (
    <IconButton
      onClick={onView}
      sx={{
        p: 0,
        top: 0,
        right: 0,
        width: 1,
        height: 1,
        zIndex: 9,
        opacity: 0,
        position: 'absolute',
        borderRadius: 1,
        justifyContent: 'center',
        bgcolor: 'grey.800',
        color: 'common.white',
        transition: theme.transitions.create(['opacity']),

        '&:hover': {
          opacity: 1,
          ...bgBlur({
            opacity: 0.64,
            color: theme.palette.grey[900],
          }),
        },
      }}
    >
      <Iconify icon="eva:eye-fill" width={24} />
    </IconButton>
  );
}

ViewButton.propTypes = {
  onView: PropTypes.func,
};
